import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORIES } from './onboardingAnalytics';

const META: Meta = {
  description: 'User added a context field',
  name: 'context_field_added',
  params: [
    {
      description: 'The source of the addition',
      name: 'source',
      required: true,
      type: 'enum',
      values: [...ONBOARDING_ANALYTICS_CATEGORIES, 'add_domain', 'manual'],
    },
    {
      description: 'The name of the field',
      name: 'field_name',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of value for the field',
      name: 'value_type',
      required: true,
      type: 'enum',
      values: ['text', 'file', 'color', 'font'],
    },
  ],
};

export default META;
